$(() => {
  if (window.matchMedia('(max-width: 1200px)').matches) {
    $('.sub-menu-toggle').click(function () {
      var clicks = $(this).data('clicks');
      if (clicks) {
        $(this).removeClass("is-active");
        $(this).parent().removeClass("is-active");
        $(this).parent().children(".sub-menu").slideUp();
      } else {
        $(this).addClass("is-active");
        $(this).parent().addClass("is-active");
        $(this).parent().children(".sub-menu").slideDown();
      }
      $(this).data("clicks", !clicks);
    });

  } else {
    $('#main-menu .menu-item-has-children').each(function () {
      var t = null;
      var li = $(this);
      li.hover(function () {
        t = setTimeout(function () {
          li.children(".sub-menu").slideDown(300);
          t = null;
        }, 300);
      }, function () {
        if (t) {
          clearTimeout(t);
          t = null;
        } else
          li.children(".sub-menu").slideUp(200);
      });
    });
  }
  $('.menu-open').click(function () {
    var clicks = $(this).data('clicks');
    if (clicks) {
      $(this).removeClass("is-active");
      $('body').removeClass("no-scroll");
      $('header').removeClass("menu-is-open");
    } else {
      $(this).addClass("is-active");
      $('body').addClass("no-scroll");
      $('header').addClass("menu-is-open");
    }
    $(this).data("clicks", !clicks);
  });
});
